/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgAvatar48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M18.953 31.5c4.187 1.75 5.048 2.86 10.548-1-.129 4.82-8.51 7.5-10.549 6.5v-5.5zm-7.161-19.43c5.171 2.465 10.472 2.325 16.618-1.33-1.173 9.165-15.822 12.09-17.887 2.97l1.269-1.64z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M14.727 18.698c-2.055-1.547-3.337-3.39-3.845-5.526a.237.237 0 01.171-.285c5.127-1.367 6.621-7.41 13.517-8.846 2.968-.618 6.144 1.319 5.915 4.725l2.019-.328a3.075 3.075 0 013.425 2.1c1.795 5.463-.364 8.768-.364 8.768M14.346 18.508h-.001a2.396 2.396 0 00-1.27 3.534l1.291 2.08c.287.461.79.742 1.334.742M19.758 31.775s-.229 3.46-.638 5.778a1.609 1.609 0 01-1.19 1.223c-1.648.405-5.077 1.244-8.064 1.974a8.538 8.538 0 00-6.368 6.75v0'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M15.193 18.226l.722 7.39a8.263 8.263 0 003.638 6.07l2.483 1.655c.112.075.228.14.348.2l.689.345c.41.205.864.31 1.323.31h0c.434 0 .862-.1 1.25-.295l.724-.36c.12-.06.236-.125.348-.2l2.483-1.655a8.263 8.263 0 003.638-6.07l.722-7.39'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28.992 31.775s.229 3.46.638 5.778c.133.602.59 1.077 1.19 1.223 1.648.405 5.077 1.244 8.064 1.974a8.538 8.538 0 016.368 6.75v0'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M15.685 39.26s1.779 2.18 3.079 3.77a4.46 4.46 0 003.452 1.636h4.319a4.46 4.46 0 003.452-1.635c1.3-1.59 3.078-3.77 3.078-3.77M13.36 18.69c1.39.015 11.738-1.855 14.636-7.66 3.604.645 2.066 6.18 6.338 7.455.025.01.05.015.076.02 0 0 0 0 0 0a2.398 2.398 0 011.27 3.535c-.472.765-.953 1.535-1.29 2.08-.287.46-.792.745-1.335.745h0'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.703 19.745s-.825 3.105-.972 3.966a.17.17 0 00.168.2h1.354'
      />
    </svg>
  );
}

export default SvgAvatar48;
